import InvalidJsonError from "@/components/InvalidJsonError";
import { Textarea } from "@/components/ui/textarea";
import { canParseJson } from "@/utils/jsonParsing";

const JsonTextArea = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => (
  <div>
    <Textarea
      className="h-[70px] w-full"
      value={value}
      placeholder="JSON value"
      onChange={e => onChange(e.target.value)}
    />
    {canParseJson(value) ? null : (
      <div className="mt-1.5">
        <InvalidJsonError />
      </div>
    )}
  </div>
);

export default JsonTextArea;
